module.exports = __webpack_public_path__ + "img/DCIBanner2.4f3dbc81.png";